// src/RoomsPage.js
import React, { useState } from 'react';
import './RoomsPage.css';
import ManageRooms from './ManageRooms';
import ManageSpecialties from './ManageSpecialties';
import ManageEquipment from './ManageEquipment';
import ManageDoctors from './ManageDoctors'; 
import WeeklyCalendarView from './WeeklyCalendarView';
import RoomAvailability from './RoomAvailability';
import DoctorShiftsView from './DoctorShiftsView'; // 🎯 NUOVO COMPONENTE
import { useUser } from './UserContext';

function RoomsPage() {
    const [activeTab, setActiveTab] = useState('weekly_view');
    const { userProfile } = useUser();

    const renderActiveTabContent = () => {
        switch (activeTab) {
            case 'weekly_view':
                return <WeeklyCalendarView />;
            case 'doctor_shifts':
                return <DoctorShiftsView />; // 🎯 TAB TURNI MEDICI
            case 'availability_finder':
                return <RoomAvailability />;
            case 'rooms':
                return <ManageRooms />;
            case 'specialties':
                return <ManageSpecialties />;
            case 'equipment':
                return <ManageEquipment />;
            case 'doctors':
                return <ManageDoctors />;
            default:
                return <WeeklyCalendarView />;
        }
    };

    return (
        <div className={`rooms-container ${activeTab !== 'weekly_view' && activeTab !== 'doctor_shifts' ? 'compact-view' : ''}`}>
            <div className="rooms-nav">
                <button 
                    onClick={() => setActiveTab('weekly_view')} 
                    className={activeTab === 'weekly_view' ? 'active' : ''}
                >
                    Planning Stanze
                </button>

                {/* 🎯 NUOVA TAB TURNI MEDICI (Subito dopo Planning Stanze) */}
                <button 
                    onClick={() => setActiveTab('doctor_shifts')} 
                    className={activeTab === 'doctor_shifts' ? 'active' : ''}
                >
                    Turni Medici
                </button>
                
                {!userProfile?.isDoctorProfile && (
                    <>
                        <button 
                            onClick={() => setActiveTab('availability_finder')} 
                            className={activeTab === 'availability_finder' ? 'active' : ''}
                        >
                            Cerca Disponibilità
                        </button>
                        <button 
                            onClick={() => setActiveTab('specialties')} 
                            className={activeTab === 'specialties' ? 'active' : ''}
                        >
                            Specialistiche
                        </button>
                        <button 
                            onClick={() => setActiveTab('equipment')} 
                            className={activeTab === 'equipment' ? 'active' : ''}
                        >
                            Macchinari
                        </button>
                        <button 
                            onClick={() => setActiveTab('rooms')} 
                            className={activeTab === 'rooms' ? 'active' : ''}
                        >
                            Stanze
                        </button>
                    </>
                )}
            </div>

            {renderActiveTabContent()}
        </div>
    );
}

export default RoomsPage;